module.exports = __webpack_public_path__ + "static/media/success-icon.26e00a99.svg";